import React from "react";
import { withRouter } from "../../utils/tms-with-router/tms-with-router";
const TmsSupport = () => {
  return <div>Hello, Welcome to Support</div>;
};
export default withRouter(TmsSupport);
